import React, { useEffect, useState, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import AttendanceRecord from "components/AttendanceModules/AttendanceRecord";
import "./attendance_master_list.css";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import ListFilters from "components/sales/ListFilters/ListFilters";
import ModalPop from "components/sales/modal/modal";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import {toast} from "react-toastify";

const AttendanceMasterList = ({
  history,
  getDaysData,
  getAllTheDaysData = [],
  getMonthsNameFilter,
  getMonthsFilter = [],
  // allValetUsers ,
  // allValetUsersData=[],
  valetAttendanceRequest
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const currentMonth = new Date().getMonth() + 1;
  const currentYear = new Date().getFullYear();
  const [ActionModal, setActionModal] = useState(false);
  const [attendanceType, setAttendanceType] = useState("");
  const [attendanceDate, setAttendanceDate] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userList, setUserList] = useState({});
  const [confirmModal, setConfirmModal] = useState(false);

  const now = new Date();
  const options = { year: "numeric", month: "long" };
  const formattedDate = now.toLocaleDateString("en-US", options);

  // useEffect(() => {
  //   (async () => {
  //     setIsLoading(true);
  //     try {
  //       const allValetUsersData = await allValetUsers();
  //       const userArray = Array.isArray(allValetUsersData?.data)
  //         ? allValetUsersData.data
  //         : [];
  //       setUserList(userArray);
  //     } catch (error) {
  //       console.error('Error fetching users:', error);
  //       setUserList([]);
  //     }
  //     setIsLoading(false);
  //   })();
  // }, []);

    const handleSubmit = async () => {

      let parsedData = {};
      if (!selectedUser) {
        const localData = localStorage.getItem('all_valet_list_filter');
        if (localData) {
          parsedData = JSON.parse(localData);
        }
      }
  
      let requestParams = {
        attendance_type : attendanceType,
        date : attendanceDate,
        user_id: parseInt(selectedUser) ? parseInt(selectedUser) : ( parseInt(parsedData?.user_id) ? parseInt(parsedData?.user_id) : null ) ,
        remarks : formData?.remarks,
        status: 'Approved'
      };

      // console.log(requestParams);
  
      try {
        const response = await valetAttendanceRequest(requestParams);
  
        if (response?.response?.status) {
          toast.success(attendanceType + 'marked successfully');
          setAttendanceType(null);
          setAttendanceDate(null);
          setFormData((prev) => ({
            ...prev,
            remarks: "",
          }));
          handleConfirmModalClose();
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          toast.error(response?.message);
          setAttendanceType(null);
          setAttendanceDate(null);
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      } catch (error) {
        setAttendanceType(null);
        setAttendanceDate(null);
        setTimeout(() => {
          window.location.reload();
        }, 3000);
      }
    };

    const handleConfirmModalClose = () => {
      setActionModal(false);
      setConfirmModal(false);
      setFormData((prev) => ({
        ...prev,
        remarks: "",
        day_type: "",
      }));
    };

  // const monthNames = [
  //   "Jan",
  //   "Feb",
  //   "Mar",
  //   "Apr",
  //   "May",
  //   "Jun",
  //   "Jul",
  //   "Aug",
  //   "Sep",
  //   "Oct",
  //   "Nov",
  //   "Dec",
  // ];

  //   const month = parseInt(filterInputList[0].months, 10) - 1;
  //   const year = filterInputList[0].year;
  // const displayValue = `${monthNames[currentMonth]} ${currentYear}`;

  const applyFilter = async (filterData) => {

    const { start_date, end_date , user_id} = filterData;

    if (!user_id) {
      toast.error("Please select an user first");
      return false;
    }

    if (!start_date || !end_date) {
      toast.error("From Date and To Date cannot be empty");
      return false;
    }
    const start = new Date(start_date);
    const end = new Date(end_date);

    if (end < start) {
      toast.error("From Date cannot be earlier than To Date");
      return false;
    }

    localStorage.setItem("all_valet_list_filter", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    console.log(filterData);
    await getDaysData(filterData);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const handleActionModalClose = () => {
    setActionModal(false);
    setFormData((prev) => ({
      ...prev,
      remarks: "",
      day_type: "",
    }));
  }

    const [formData, setFormData] = useState({
      day_type: "",
      remarks: "",
    });

  return (
    <>
      <Layout
        // title={`Attendance Record ` + `(` + displayValue + `)`}
        title={`Attendance Record `}
        isLoading={isLoading}
        Buttons={headerBtns}
      >
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <div className="container-fluid common-bg">
              {/*Heading*/}
              <div className="container-fluid bootstrap snippets bg-white">
                <AttendanceRecord
                  records={getAllTheDaysData?.data}
                  getMonthsFilter={getMonthsFilter}
                  getDaysData={getDaysData}
                  setAttendanceType={setAttendanceType}
                  setAttendanceDate={setAttendanceDate}
                  setSelectedUser={setSelectedUser}
                  setActionModal={setActionModal}
                />
              </div>
            </div>
          </div>
        </div>

        <ModalPop
          title={localization.conf}
          show={ActionModal}
          handleModalHide={handleActionModalClose}
          keyboard
          backdrop
        >
          <div className="text-center">
            <h4>
              {`Are you sure you want to mark ` + attendanceType + `?`}
            </h4>
            <div className="col-md-12">
              <TextAreaInput
                type="text"
                rows={4}
                label={"Remarks"}
                inputValue={formData?.remarks}
                isStarRequired={true}
                handleChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
              />
            </div>
            <div className="col-md-6 d-flex mt-5">
              <div className="col-md-3">
                <Button
                  className="btn btn-danger"
                  onClick={handleActionModalClose}
                >
                  No
                </Button>
              </div>
              <div className="col-md-3">
                <Button className="btn btn-success" onClick={handleSubmit}>
                  Yes
                </Button>
              </div>
            </div>
          </div>
        </ModalPop>
        <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          // userList={userList}
          setSelectedUser={setSelectedUser}
          masterAttendanceFilter
        />
      </Layout>
      {/* section ends */}
    </>
  );
};

export default AttendanceMasterList;
